import { useContext } from "react";

import { FlowContext, FlowContextType } from "@components/Flow/FlowProvider";

const useFlow = (): FlowContextType => useContext<FlowContextType>(FlowContext);

export default useFlow;
